import { createSlice } from "@reduxjs/toolkit";
import { createShiftGroup, deleteShiftGroup, shiftGroupListsApis, shiftList, updateShiftGroup, createShift, getShiftById, updateShift, deleteShift,getShiftGroupById } from "./ShiftGroupActions";
import { shiftListApi,createShiftApi, } from "./ShiftGroupApi";
const initialState = {
    shiftGroupData: [],
    shiftGroupById: null,
    meta: {
        totalRecords:0,
        totalPages:0,
        CurrentPage:1,
        pageSize:5,
    },
    shiftData: [],
    shiftMeta: { totalRecords: 0, totalPages: 0, currentPage: 1, pageSize: 10 },
    shiftById: null,
    status: "idle",
    error: null,
    updateStatus: "idle",
    updateError: null,      
};

const shiftGroupSlice = createSlice({
    name: "shiftGroup",
    initialState,

    reducers: {
        clearShiftGroupData(state){
            return initialState;
        },
    },

    extraReducers: (builder) => {
        builder

        .addCase(shiftGroupListsApis.pending, (state) => {
            state.status = "loading";
            state.error = null;
        })
        .addCase(shiftGroupListsApis.fulfilled, (state, action) => {
            state.status= "succeeded";


            const paged = action.payload?.data?.data || [];

            const list = paged?.data || [];

            state.shiftGroupData = Array.isArray(list) ? list: [];

            state.meta = {
                totalRecords: paged?.TotalRecords ?? 0,
                totalPages: paged?.TotalPages ?? 0,
                currentPage: paged?.CurrentPage ?? 0,
                pageSize: paged?.PageSize ?? 0,
            }
        })

        .addCase(shiftGroupListsApis.rejected, (state, action) => {
            state.status = "failed";
            state.error = action.payload;
        })

        .addCase(getShiftGroupById.pending, (state) => {
    state.status = "loading";
    state.error = null;
    state.shiftGroupById = null;
})

.addCase(getShiftGroupById.fulfilled, (state, action) => {
    state.status = "succeeded";
    state.shiftGroupById = action.payload.data;
})

.addCase(getShiftGroupById.rejected, (state, action) => {
    state.status = "failed";
    state.error = action.payload;
})
        .addCase(updateShiftGroup.pending, (state) => {
            state.status = "loading";
            state.error = "null";
        })
        .addCase(updateShiftGroup.fulfilled, (state, action) => {
            state.status = "succeeded";
        })
        .addCase(updateShiftGroup.rejected, (state,action) => {
            state.status = "failed";
            state.error = action.payload;
        })
        .addCase(createShiftGroup.pending, (state) => {
            state.status = "loading";
            state.error = "null";
        })
        .addCase(createShiftGroup.fulfilled, (state, action) =>{
            state.status = "succeeded";
        })
        .addCase(createShiftGroup.rejected, (state, action) => {
            state.status = "failed";
            state.error =action.payload;
        })
        .addCase(deleteShiftGroup.pending, (state) =>{
            state.status = "loading";
            state.error = null;
        })
        .addCase(deleteShiftGroup.fulfilled, (state, action) => {
            state.status ="succeeded";
        })
       .addCase(deleteShiftGroup.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload
       })
       .addCase(shiftList.pending, (state) => {
        state.status = "loading";
        state.error = null;
       })
       .addCase(shiftList.fulfilled, (state, action) => {
        state.status = "succeeded";
        const paged = action.payload?.data?.data || {};
        const list = paged?.data;
        state.shiftData = Array.isArray(list) ? list : [];
        state.shiftMeta = {
            totalRecords: paged?.TotalRecords ?? 0,
            totalPages: paged?.TotalPages ?? 0,
            currentPage: paged?.CurrentPage ?? 1,
            pageSize: paged?.PageSize ?? 10,
        };
       })
       .addCase(shiftList.rejected, (state, action) => {
        state.status = "failed";
        state.error =action.payload;
       })
       .addCase(createShift.pending, (state) => {
    state.status = "loading";
    state.error = null;
})

.addCase(createShift.fulfilled, (state) => {
    state.status = "succeeded";
})

.addCase(createShift.rejected, (state, action) => {
    state.status = "failed";
    state.error = action.payload;
})

.addCase(getShiftById.pending, (state) => {
    state.status = "loading";
    state.error = null;
    state.shiftById = null;
})

.addCase(getShiftById.fulfilled, (state, action) => {
    state.status = "succeeded";
    state.shiftById = action.payload?.data?.data?.data || null;
})

.addCase(getShiftById.rejected, (state, action) => {
    state.status = "failed";
    state.error = action.payload;
})

.addCase(updateShift.pending, (state) => {
    state.status = "loading";
    state.error = null;
})

.addCase(updateShift.fulfilled, (state) => {
    state.status = "succeeded";
})

.addCase(updateShift.rejected, (state, action) => {
    state.status = "failed";
    state.error = action.payload;
})
.addCase(deleteShift.pending, (state) => {
    state.status = "loading";
    state.error = null;
})

.addCase(deleteShift.fulfilled, (state) => {
    state.status = "succeeded";
})

.addCase(deleteShift.rejected, (state, action) => {
    state.status = "failed";
    state.error = action.payload;
})
    }
});
export const  { clearShiftGroupData } = shiftGroupSlice.actions;

export default shiftGroupSlice.reducer;